module.exports = __webpack_public_path__ + "img/net-shipping-cost.68e5ac00.svg";